import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../utils/api';

export default function QcEvaluationPage(){
  const { id } = useParams();
  const [rows,setRows]=useState([]);
  const [memberName,setMemberName]=useState('');
  const [remarks,setRemarks]=useState('');
  const [passFail,setPassFail]=useState(true);
  const [loading,setLoading]=useState(false);
  const max=3;
  const [files,setFiles]=useState({});

  const load=async()=>{
    const res=await api.get(`/api/v1/inventory/qc/evaluation/${id}`);
    setRows(res.data||[]);
  };
  useEffect(()=>{ load(); },[id]);

  const handleSubmit=async e=>{
    e.preventDefault();
    if(rows.length>=max) return;
    setLoading(true);
    await api.post(`/api/v1/inventory/qc/evaluation/${id}`,{memberName,remarks,passFail});
    setMemberName(''); setRemarks(''); setPassFail(true);
    await load();
    setLoading(false);
  };

  return (
    <div className="inventory-page">
      <div className="premium-card inventory-page-card">
      <h2>QC Evaluation</h2>
      <p>Dispatch Note ID: {id}</p>
      <div className="progress mb-3" style={{height:20}}>
        <div className="progress-bar" style={{width:`${rows.length*33.33}%`}}>{rows.length}/3</div>
      </div>

      <table className="table table-bordered">
        <thead><tr><th>#</th><th>Member</th><th>Remarks</th><th>Passed</th><th>At</th></tr></thead>
        <tbody>{rows.map((r,i)=>(<tr key={r.id}><td>{i+1}</td><td>{r.memberName}</td><td>{r.remarks}</td><td>{r.passFail?'✅':'❌'}</td><td>{r.createdAt}</td></tr>))}</tbody>
      </table>

      {rows.length<max && (
        <form onSubmit={handleSubmit} className="card p-3 mb-4">
          <h5>Add Evaluation</h5>
          <div className="mb-2"><label>Member Name</label><input className="form-control" value={memberName} onChange={e=>setMemberName(e.target.value)} required/></div>
          <div className="mb-2"><label>Remarks</label><textarea className="form-control" value={remarks} onChange={e=>setRemarks(e.target.value)} required/></div>
          <div className="mb-2"><label className="form-label">Result</label><select className="form-select" value={passFail} onChange={e=>setPassFail(e.target.value==='true')}><option value="true">Pass</option><option value="false">Fail</option></select></div>
          <button className="btn btn-primary" disabled={loading}>{loading?'Saving...':'Submit'}</button>
        </form>
      )}

      {rows.length>0 && rows.every(r=>r.passFail) && (
        <div className="card p-3">
          <h5>Issue Final Receipt</h5>
          <p>Upload signatures for each role:</p>
          <div className="row mb-2">
            {["store_officer","qc_member_1","qc_member_2","qc_member_3"].map(role=> (
              <div key={role} className="col-md-6 mb-2">
                <label className="form-label text-capitalize">{role.replace(/_/g,' ')}</label>
                <input type="file" accept="image/*" className="form-control" onChange={e=>{
                  const file=e.target.files[0];
                  setFiles(prev=>({...prev,[role]:file}));
                }}/>
              </div>
            ))}
          </div>
          <button className="btn btn-success" disabled={loading || Object.keys(files).length<4} onClick={async()=>{
            setLoading(true);
            try{
              const fd=new FormData();
              Object.entries(files).forEach(([role,file])=>fd.append(role,file));
              const res=await api.post(`/api/v1/inventory/receipt/${id}/issue`,fd,{headers:{'Content-Type':'multipart/form-data'}});
              window.open(res.data.pdf,'_blank');
              alert('Final receipt issued');
            }catch(err){ alert(err.response?.data?.message||err.message);} finally{ setLoading(false);}        }}>Issue Receipt</button>
        </div>
      )}
      </div>
    </div>
  );
}
